var _path, _circle, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1735 12.8173L18.7537 6.27188H3.24631L9.82755 12.8184L9.82774 12.8186C10.141 13.1319 10.557 13.3042 11 13.3042C11.443 13.3042 11.8589 13.1319 12.1734 12.8175L12.1735 12.8173ZM2.75781 4.9H19.2422C20.2688 4.9 21.1 5.73644 21.1 6.75781V17.3047C21.1 18.3322 20.2626 19.1625 19.2422 19.1625H2.75781C1.73995 19.1625 0.9 18.3358 0.9 17.3047V6.75781C0.9 5.73834 1.72789 4.9 2.75781 4.9ZM19.7281 16.8258V7.23759L14.906 12.0343L19.7281 16.8258ZM8.06668 13.0018L3.24724 17.7906H18.7528L13.9333 13.0018L13.1423 13.7887C12.5702 14.3608 11.8091 14.6761 11 14.6761C10.191 14.6761 9.42982 14.3608 8.85878 13.7898L8.06668 13.0018ZM2.27188 7.23759V16.8258L7.09402 12.0343L2.27188 7.23759Z",
    fill: "#FF761C",
    stroke: "#FF761C",
    strokeWidth: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 5.5,
    fill: "white",
    stroke: "#FF761C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7468 2.81933C17.8238 2.57031 18.1762 2.57032 18.2532 2.81933L18.8866 4.86897C18.9209 4.98 19.0235 5.05573 19.1397 5.05573H21.2166C21.4701 5.05573 21.5789 5.37743 21.3775 5.53131L19.6748 6.83206C19.5865 6.89948 19.5497 7.01477 19.5824 7.12088L20.2274 9.20787C20.3035 9.45438 20.0183 9.65332 19.8133 9.49669L18.1609 8.23435C18.0659 8.1618 17.9341 8.1618 17.8391 8.23435L16.1867 9.49669C15.9817 9.65332 15.6965 9.45437 15.7726 9.20787L16.4176 7.12088C16.4503 7.01477 16.4135 6.89948 16.3252 6.83206L14.6225 5.53131C14.4211 5.37743 14.5299 5.05573 14.7834 5.05573H16.8603C16.9765 5.05573 17.0791 4.98 17.1134 4.86897L17.7468 2.81933Z",
    fill: "#FF761C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerification);
export default __webpack_public_path__ + "static/media/email-verification.a63b9d52693c0a0420830cd91ef7c14f.svg";
export { ForwardRef as ReactComponent };